module.exports = __webpack_public_path__ + "legacy-60da435f239c63150225abedea3df1b9.svg";